import AdminOperationsScreen from "../../../src/features/arrangements/screens/AdminOperationsScreen";
export default function CaseContractRoute() { return <AdminOperationsScreen screenIdOverride="contract-builder" />; }
